import React from 'react';

import {Create} from 'react-admin';

import ChallengeForm from "./ChallengeForm";

const ChallengeCreate = (props) => (
	<Create {...props}><ChallengeForm/></Create>
);

export default ChallengeCreate;
